import { getActivityUsersAsync } from 'API/order/activities/getActivityUsersAsync';
import { createKeyedDataAsyncSlice } from 'store/createKeyedDataAsyncSlice';

export const { slice: activityUsersSlice, asyncAction: getActivityUsersAsyncAction } = createKeyedDataAsyncSlice(
  'activityUsersSlice',
  getActivityUsersAsync,
  ({ orderId }) => orderId
);
